import { render, staticRenderFns } from "./widget_favorite_search.vue?vue&type=template&id=a4caf332&scoped=true&"
import script from "./widget_favorite_search.vue?vue&type=script&lang=js&"
export * from "./widget_favorite_search.vue?vue&type=script&lang=js&"
import style0 from "./widget_favorite_search.vue?vue&type=style&index=0&id=a4caf332&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4caf332",
  null
  
)

export default component.exports